import { computed, defineAsyncComponent, defineComponent, ref } from 'vue';
import CabinetFormComponent from '@/components/cabinetForm/CabinetForm.vue';

export default defineComponent({
  name: 'CabinetDocumentPage',
  components: {
    CabinetFormComponent,
    AsyncCabinetTableComponent: defineAsyncComponent(() => import('@/components/cabinetTable/CabinetTable.vue')),
    AsyncCabinetDetailComponent: defineAsyncComponent(() => import('@/components/cabinetDetail/CabinetDetail.vue')),
  },
  setup: () => {
    const cabinetId = ref<number | null>(null);
    const cabinetForm = ref<InstanceType<typeof CabinetFormComponent>>();
    const cabinetComponent = computed(() => `async-cabinet-${cabinetId.value ? 'detail' : 'table'}-component`);

    const toggleCabinet = (id: number | null) => {
      cabinetId.value = id;
    };

    const show = () => {
      cabinetForm.value?.show();
    };

    return {
      cabinetId,
      cabinetForm,
      cabinetComponent,
      toggleCabinet,
      show,
    };
  },
});
